
import Loader from "@/components/Loader.vue"
import events from "@/events";
import { defineComponent, ref } from "vue";

export default defineComponent({
    components: { Loader },
    setup() {
        const loading = ref(false);
        events.on('load:start', () => loading.value = true)
        events.on('load:done', () => loading.value = false)
        return { loading }
    }
})
